/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
    pageTitle: '',
    showPageTitle: true,
    showToggleButton: true,
    showSearchBox: false,
    showFilterButton: false,
    showReturnButton: false,
    showSaveButton: false,
    saveState: false
}

const getters = {
    getPageTitle: state => {
        return state.pageTitle
    },
    getShowPageTitle: state => {
        return state.showPageTitle
    },
    getShowToggleButton: state => {
        return state.showToggleButton
    },
    getShowSearchBox: state => {
        return state.showSearchBox
    },
    getShowFilterButton: state => {
        return state.showFilterButton
    },
    getShowReturnButton: state => {
        return state.showReturnButton
    },
    getShowSaveButton: state => {
        return state.showSaveButton
    },
    getSaveState: state => {
        return state.saveState
    }
}

const mutations = {
    changePage(state, {
        pageName
    }) {
        state.pageTitle = 'menu.' + pageName
    },
    setPageTitle(state, text) {
        state.pageTitle = text
    },
    setToolbar(state, patternTool) {
        switch (patternTool) {
            case "1": // ไว้ใช้กับหน้า List
                state.showPageTitle = false
                state.showToggleButton = true
                state.showSearchBox = true
                state.showFilterButton = true
                state.showReturnButton = false
                state.showSaveButton = false
                break;
            case "2": // ไว้ใช้กับหน้า Create และ Edit
                state.showPageTitle = true
                state.showToggleButton = false
                state.showSearchBox = false
                state.showFilterButton = false
                state.showReturnButton = true
                state.showSaveButton = true
                break;
            default:
                state.showPageTitle = true
                state.showToggleButton = true
                state.showSearchBox = false
                state.showFilterButton = false
                state.showReturnButton = false
                state.showSaveButton = false
                break;
        }
    },
    setSaveState(state, status) {
        state.saveState = status
    },
    setToolbarLogout(state){
        state.pageTitle= '',
        state.showPageTitle= true,
        state.showToggleButton= true,
        state.showSearchBox= false,
        state.showFilterButton= false,
        state.showReturnButton= false,
        state.showSaveButton= false,
        state.saveState= false
    }
}

const actions = {
    changePage({
        commit
    }, {
        pageName
    }) {
        commit("changePage", {
            pageName: pageName
        })
    },
    setPageTitle({
        commit
    }, text) {
        commit("setPageTitle", 'menu.' + text)
    },
    setToolbar({
        commit
    }, {
        pageTitle,
        patternTool
    }) {
        //commit("setPageTitle", pageTitle)
        commit("setToolbar", patternTool)
    },
    setSaveState({
        commit
    }, {
        status
    }) {
        commit("setSaveState", status)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}